import { getInfo, getLanguage, loginByUsername, loginBySsoToken, logout } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { getDicts } from '@/api/dict/dictType'
import { loginByAppToken } from '../../api/login'

const state = {
  token: getToken(),
  id: '',
  name: '',
  username: '',
  userType: '',
  departId: undefined,
  departName: undefined,
  departs: [],
  introduction: '',
  dicts: [],
  multiLanguage: []
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_INTRODUCTION: (state, introduction) => {
    state.introduction = introduction
  },
  SET_ID: (state, id) => {
    state.id = id
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_USERNAME: (state, username) => {
    state.username = username
  },
  SET_USERTYPE: (state, userType) => {
    state.userType = userType
  },
  SET_DEPARTID: (state, departId) => {
    state.departId = departId
  },
  SET_DEPARTNAME: (state, departName) => {
    state.departName = departName
  },
  SET_DEPARTS: (state, departs) => {
    state.departs = departs
  },
  // 数据字典
  SET_DICTS: (state, dicts) => {
    state.dicts = dicts
  },
  // 系统语言
  SET_MULTI_LANGUAGE: (state, multiLanguage) => {
    state.multiLanguage = multiLanguage
  }
}

const actions = {
  // 用户名登录
  async LoginByUsername({ commit }, userInfo) {
    const { username, password } = userInfo
    const { data } = await loginByUsername(username.trim(), password)
    if (!data.token) {
      return Promise.reject('error')
    } else {
      setToken(data.token)
      commit('SET_TOKEN', data.token)
    }
  },

  // 根据ssoToken获取access_token
  async loginBySsoToken({ commit }, ssoToken) {
    const { data } = await loginBySsoToken(ssoToken)
    if (!data.token) {
      return Promise.reject('error')
    } else {
      setToken(data.token)
      commit('SET_TOKEN', data.token)
    }
  },

  // 根据appToken获取业务系统token
  async loginByAppToken({ commit }, appToken) {
    const { data } = await loginByAppToken(appToken)
    if (!data.token) {
      return Promise.reject('error')
    } else {
      setToken(data.token)
      commit('SET_TOKEN', data.token)
    }
  },

  // 获取用户信息
  async GetInfo({ commit }) {
    const { data } = await getInfo()
    commit('SET_ID', data.id)
    commit('SET_NAME', data.name)
    commit('SET_USERNAME', data.username)
    commit('SET_USERTYPE', data.type)
    commit('SET_DEPARTID', data.departId)
    commit('SET_DEPARTNAME', data.departName)
    commit('SET_DEPARTS', data.userDeparts)
    commit('SET_INTRODUCTION', data.description)
    const { data: multiLanguage } = await getLanguage()
    commit('SET_MULTI_LANGUAGE', multiLanguage)
    const { data: dicts } = await getDicts()
    commit('SET_DICTS', dicts)
  },

  // 登出
  async LogOut({ commit, state }) {
    await logout(state.token)
    commit('SET_TOKEN', '')
    await removeToken()
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
